import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/t/$tenantId/admin/')({
  component: AdminRouteLayout,
});

function AdminRouteLayout() {
  return <Outlet />;
}
